export default class Command {
    constructor(item) {
        this.id = item != null ? item.id : ''
        this.workOrderId = item != null ? item.workOrderId : ''
        this.description= item != null ? item.description : ''
        this.edition= item != null ? item.edition : ''
        this.size= item != null ? item.size : ''
        this.format= item != null ? item.format : ''
        this.printing= item != null ? item.printing : ''
        this.material= item != null ? item.material : ''
        this.finish= item != null ? item.finish : ''
        this.purchaseAmount = item != null ? item.purchaseAmount : 0
        this.salesAmount = item != null ? item.salesAmount : 0
        this.note= item != null ? item.note : '',
        this.customId = item != null ? item.customId : 0;
        this._showDetails = false;
    }
}